import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

function NotFoundPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#1c3d6e] via-[#1e3a8a] to-[#334E7D] flex items-center justify-center text-white">
      <div className="text-center px-6">
        <h1 className="text-8xl font-extrabold tracking-tight">404</h1>
        <p className="mt-4 text-2xl font-semibold">
          Oops! The page you're looking for doesn't exist.
        </p>
        <p className="mt-2 text-lg text-gray-300">
          It seems you've found yourself off the map. Don't worry, let's get you back on track.
        </p>
        <div className="mt-6">
          <Link
            to="/"
            className="inline-flex items-center px-6 py-3 bg-white text-[#1e3a8a] font-medium rounded-xl shadow-lg hover:bg-blue-100 transition-colors group"
          >
            <ArrowLeft className="w-5 h-5 mr-2 group-hover:-translate-x-1 transition-transform" />
            Back to Homepage
          </Link>
        </div>
        <div className="mt-10 relative">
          <div className="absolute -top-8 -right-8 w-32 h-32 bg-blue-500/20 rounded-full blur-3xl"></div>
          <div className="absolute -bottom-8 -left-8 w-32 h-32 bg-purple-500/20 rounded-full blur-3xl"></div>
          <img
            src="https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=600&h=400&fit=crop"
            alt="404 Illustration"
            className="w-full max-w-md mx-auto rounded-lg shadow-xl border border-white/10"
          />
        </div>
      </div>
    </div>
  );
}

export default NotFoundPage;
